<template>
	<div class="modal fade" :id="id" role="dialog" tabindex="-1" data-bs-backdrop="static">
		<div class="modal-dialog modal-xl" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title">
						<i class="far fa-file-pdf me-2"></i>Stampa — Template
					</h6>
					<span v-if="bloccato" class="badge bg-warning text-dark ms-auto me-2"><i class="ph-lock me-1"></i>In modifica da {{ lock.USERNAME }} — sola lettura</span>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>

				<div class="modal-body">
					<!-- Barra template -->
					<div class="d-flex align-items-center flex-wrap gap-2 mb-3">
						<label class="form-label fw-semibold mb-0 me-1">Template:</label>
						<select class="form-select" style="width: 260px;" v-model="idTemplate" @change="selezionaTemplate()">
							<option v-for="t in templates" :key="t.ID_REPORT_TEMPLATE" :value="t.ID_REPORT_TEMPLATE">
								{{ t.NOME }}<span v-if="t.FLG_DEFAULT == 1"> (predefinito)</span>
							</option>
						</select>

						<button class="btn btn-danger" @click="stampa()" :disabled="!idTemplate">
							<i class="far fa-file-pdf me-1"></i> Stampa
						</button>

						<button v-if="canCreate" class="btn btn-light" @click="nuovo()">
							<i class="far fa-plus me-1"></i> Nuovo
						</button>
						<button v-if="canCreate" class="btn btn-light" @click="duplica()" :disabled="!idTemplate">
							<i class="far fa-copy me-1"></i> Duplica
						</button>
						<button v-if="canUpdate && !bloccato" class="btn btn-light" @click="impostaPredefinito()" :disabled="!idTemplate || isNuovo">
							<i class="far fa-star me-1"></i> Predefinito
						</button>
						<button v-if="canDelete && !bloccato" class="btn btn-light text-danger" @click="elimina()" :disabled="!idTemplate || isNuovo">
							<i class="far fa-trash-alt me-1"></i> Elimina
						</button>

						<div class="ms-auto d-flex align-items-center gap-2" v-if="canUpdate">
							<ISwitch v-model="flgEditor"></ISwitch>
							<span class="small">Modifica template</span>
						</div>
					</div>

					<!-- Impostazioni -->
					<fieldset class="row" v-if="flgEditor" :disabled="bloccato" :class="{ 'pe-none opacity-75': bloccato }">
						<div class="col-lg-6">
							<div class="mb-3">
								<label class="form-label fw-semibold">Nome template</label>
								<input type="text" class="form-control" v-model="modello.NOME" placeholder="es. Standard">
							</div>

							<div class="row mb-3">
								<div class="col-6">
									<label class="form-label fw-semibold">Font</label>
									<select class="form-select" v-model="cfg.FONT">
										<option v-for="f in fontDisponibili" :key="f.id" :value="f.id">{{ f.text }}</option>
									</select>
								</div>
								<div class="col-6">
									<label class="form-label fw-semibold">Dimensione testo (%)</label>
									<input type="number" class="form-control" min="50" max="200" step="5" v-model.number="cfg.SCALA_FONT">
								</div>
							</div>

							<div class="mb-3">
								<label class="form-label fw-semibold d-block">Bordi tabella</label>
								<div class="d-flex align-items-center gap-3 flex-wrap">
									<ISwitch v-model="cfg.FLG_BORDI"></ISwitch>
									<ColorPicker v-model="cfg.BORDO_COLORE" :disabled="cfg.FLG_BORDI != 1"></ColorPicker>
									<div class="d-flex align-items-center gap-1">
										<span class="small text-muted">Spessore</span>
										<input type="number" class="form-control" style="width: 90px;" min="0.05" max="2" step="0.05"
											v-model.number="cfg.BORDO_SPESSORE" :disabled="cfg.FLG_BORDI != 1">
									</div>
								</div>
							</div>

							<div class="mb-3">
								<label class="form-label fw-semibold d-block">Chiusura</label>
								<div class="d-flex align-items-center gap-2">
									<ISwitch v-model="cfg.FLG_PAGINA_FINALE"></ISwitch>
									<span class="small">Validità, accettazione, condizioni e pagamento sempre su una pagina a parte</span>
								</div>
							</div>

							<div class="mb-3">
								<label class="form-label fw-semibold d-block">Colori</label>
								<div v-for="c in campiColore" :key="c.campo" class="d-flex align-items-center gap-2 mb-2">
									<span class="small" style="width: 190px;">{{ c.label }}</span>
									<ColorPicker v-model="cfg[c.campo]"></ColorPicker>
								</div>
							</div>

						</div>

						<div class="col-lg-6">
							<label class="form-label fw-semibold d-block">Testi personalizzati</label>
							<div class="d-flex align-items-start gap-1 mb-2">
								<button type="button" class="btn btn-light btn-sm px-2" title="Testo precedente"
									@click="scorriTesto(-1)"><i class="fal fa-chevron-left"></i></button>
								<ul class="nav nav-pills gap-1 flex-grow-1">
									<li class="nav-item" v-for="t in campiTesto" :key="t.campo">
										<button type="button" class="nav-link py-1 px-2 small"
											:class="testoAttivo == t.campo ? 'active' : 'text-body'"
											:title="t.descrizione" @click="testoAttivo = t.campo">
											{{ t.label }}
											<i v-if="cfg.TESTI[t.campo]" class="fas fa-circle ms-1" style="font-size: .35rem; vertical-align: middle;"></i>
										</button>
									</li>
								</ul>
								<button type="button" class="btn btn-light btn-sm px-2" title="Testo successivo"
									@click="scorriTesto(1)"><i class="fal fa-chevron-right"></i></button>
							</div>
							<div class="form-text mb-1">{{ testoCorrente.descrizione }} — vuoto = testo standard, tradotto nella lingua del report.</div>
							<!-- Un solo editor per tutti i testi: il componente aggiorna il contenuto da se'
								quando cambia il campo legato, rimontarlo con :key rompeva il DOM di CKEditor. -->
							<ckeditor :editor="editor" v-model="cfg.TESTI[testoAttivo]" :config="editorConfig"></ckeditor>
							<button type="button" class="btn btn-link btn-sm text-danger px-0 mb-3"
								:disabled="!cfg.TESTI[testoAttivo]" @click="cfg.TESTI[testoAttivo] = ''">
								Ripristina il testo standard
							</button>

							<div class="mb-3">
								<label class="form-label fw-semibold d-block">Colonne</label>
								<draggable v-model="cfg.ORDINE_COLONNE" handle=".handle" :animation="150" tag="ul" class="list-group">
									<li v-for="c in cfg.ORDINE_COLONNE" :key="c"
										class="list-group-item d-flex align-items-center gap-2 py-1">
										<i class="fas fa-grip-vertical text-muted handle cursor-pointer"></i>
										<span class="small flex-grow-1">{{ labelColonna(c) }}</span>
										<span v-if="c == 'DESCRIZIONE'" class="badge bg-light text-muted">sempre visibile</span>
										<ISwitch v-else v-model="cfg.COLONNE[c]"></ISwitch>
									</li>
								</draggable>
								<div class="form-text">Trascina per cambiare l'ordine. La descrizione è sempre visibile e occupa lo spazio delle colonne nascoste.</div>
							</div>
						</div>
					</fieldset>
				</div>

				<div class="modal-footer">
					<button type="button" class="btn btn-light" data-bs-dismiss="modal">
						<i class="fal fa-times me-1"></i> Chiudi
					</button>
					<button type="button" class="btn btn-secondary" @click="apriAnteprima()" :disabled="!idTemplate || isNuovo">
						<i class="far fa-eye me-1"></i> Mostra anteprima
					</button>
					<button v-if="flgEditor && canUpdate && !bloccato" type="button" class="btn btn-primary" @click="salva()">
						<i class="far fa-save me-1"></i> Salva
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- Anteprima in un modale sopra a quello del template: l'iframe e' alto e
		dentro le impostazioni rubava meta' finestra. -->
	<div class="modal fade" :id="id + '_anteprima'" role="dialog" tabindex="-1" data-bs-backdrop="false" style="z-index: 1060;">
		<div class="modal-dialog modal-xl modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title">
						<i class="far fa-eye me-2"></i>Anteprima — {{ modello.NOME }}
					</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body p-0">
					<iframe v-if="previewUrl" :src="previewUrl" style="width: 100%; height: 80vh; border: 0;"></iframe>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { utils } from '../../assets/js/utils'
import ISwitch from '../utils/ISwitch.vue'
import ColorPicker from '../utils/ColorPicker.vue'
import ClassicEditor from '@/utils/CustomCKEditor'
import { VueDraggableNext } from 'vue-draggable-next'

// Default = layout storico del report: un template con queste impostazioni stampa
// esattamente come prima che i template esistessero.
const CFG_DEFAULT = {
	FONT: 'helvetica',
	SCALA_FONT: 100,
	FLG_BORDI: 1,
	BORDO_COLORE: '#000000',
	BORDO_SPESSORE: 0.2,
	COLORE_INTESTAZIONE: '#000000',
	COLORE_TESTO_INTESTAZIONE: '#FFFFFF',
	COLORE_ATTIVITA: '#D3D3D3',
	COLORE_SOTTO_ATTIVITA: '#F2F2F2',
	COLORE_TESTO: '#000000',
	COLONNE: { PREZZO: 1, GIORNI: 1, QTA: 1, RIP: 1, TOTALE: 1 },
	ORDINE_COLONNE: ['DESCRIZIONE', 'PREZZO', 'GIORNI', 'QTA', 'RIP', 'TOTALE'],
	FLG_PAGINA_FINALE: 1,
	TESTI: { PIE_PAGINA: '', NOTE_PREZZI: '', OFFERTA_VALIDA: '', ACCETTAZIONE: '', DICHIARAZIONE: '', PAGAMENTO: '', FIRMA: '' },
};

export default {
	name: 'ReportTemplateModal',

	components: { ISwitch, ColorPicker, draggable: VueDraggableNext },

	props: {
		id: { type: String, default: 'popUpReportTemplate' },
		idReport: { type: [Number, String], required: true },
		// URL di stampa senza ID_TEMPLATE, es. "theb/report?ID_REPORT=1006&FK_ID_PROGETTO=12&LANG=118"
		urlStampa: { type: String, default: '' },
	},

	data() {
		return {
			filters: global.filters,
			editor: ClassicEditor,
			// Campo vuoto = il report stampa il testo standard: il placeholder lo ricorda
			editorConfig: { height: 200, placeholder: 'Vuoto: si stampa il testo standard' },
			templates: new Array(),
			idTemplate: null,
			modello: { NOME: '' },
			cfg: utils.clone(CFG_DEFAULT),
			flgEditor: 0,
			testoAttivo: 'NOTE_PREZZI',
			previewUrl: '',
			lock: null,
			lockHandle: null,
			// Solo i font presenti in LIB/ISPRINT_LIB/TCPDF_LAST/fonts, altrimenti TCPDF va in errore
			fontDisponibili: [
				{ id: 'helvetica', text: 'Helvetica' },
				{ id: 'times', text: 'Times' },
				{ id: 'courier', text: 'Courier' },
				{ id: 'dejavusans', text: 'DejaVu Sans' },
				{ id: 'roboto', text: 'Roboto' },
			],
			campiColore: [
				{ campo: 'COLORE_INTESTAZIONE', label: 'Barra intestazione' },
				{ campo: 'COLORE_TESTO_INTESTAZIONE', label: 'Testo intestazione' },
				{ campo: 'COLORE_ATTIVITA', label: 'Riga attività' },
				{ campo: 'COLORE_SOTTO_ATTIVITA', label: 'Riga sotto-attività' },
				{ campo: 'COLORE_TESTO', label: 'Testo' },
			],
			campiColonna: [
				{ campo: 'DESCRIZIONE', label: 'Descrizione' },
				{ campo: 'PREZZO', label: 'Prezzo unitario' },
				{ campo: 'GIORNI', label: 'Giorni' },
				{ campo: 'QTA', label: 'Q.tà' },
				{ campo: 'RIP', label: 'Rip' },
				{ campo: 'TOTALE', label: 'Totale' },
			],
			// label = etichetta breve del pill, descrizione = riga sotto i pill e tooltip
			campiTesto: [
				{ campo: 'NOTE_PREZZI', label: 'Nota prezzi', descrizione: 'Nota prezzi, subito sotto il Totale Generale' },
				{ campo: 'OFFERTA_VALIDA', label: 'Validità', descrizione: 'Validità offerta, in testa alla pagina di chiusura' },
				{ campo: 'ACCETTAZIONE', label: 'Accettazione', descrizione: 'Testo accettazione preventivo' },
				{ campo: 'DICHIARAZIONE', label: 'Dichiarazione', descrizione: 'Dichiarazione condizioni di fornitura' },
				{ campo: 'PAGAMENTO', label: 'Pagamento', descrizione: 'Modalità di pagamento' },
				{ campo: 'FIRMA', label: 'Firma', descrizione: 'Firma (in basso a destra)' },
				{ campo: 'PIE_PAGINA', label: 'Piè di pagina', descrizione: 'Piè di pagina (recapiti)' },
			],
		};
	},

	computed: {
		canCreate() { return this.$root.isGod || utils.permissions.hasFunzionalita('REPORTTEMPLATE_CREATE'); },
		canUpdate() { return this.$root.isGod || utils.permissions.hasFunzionalita('REPORTTEMPLATE_UPDATE'); },
		canDelete() { return this.$root.isGod || utils.permissions.hasFunzionalita('REPORTTEMPLATE_DELETE'); },
		testoCorrente() { return utils.array.select(this.campiTesto, 'campo', this.testoAttivo, 1)[0] || {}; },
		// I template non ancora salvati hanno id negativo: niente elimina/predefinito
		isNuovo() { return this.idTemplate != null && this.idTemplate < 0; },
		bloccato() { return this.lock != null && !this.lock.MIO; },
	},

	// Lock solo in modifica di un template salvato: chi apre il modale per stampare non blocca nessuno
	watch: {
		flgEditor() { this.aggiornaLock(); },
		idTemplate() { this.aggiornaLock(); },
	},

	created() {
		this.caricaTemplates();
	},

	mounted() {
		document.getElementById(this.id).addEventListener('hidden.bs.modal', (e) => {
			if (e.target.id == this.id) { this.flgEditor = 0; this.rilasciaLock(); }
		});
	},

	beforeUnmount() {
		this.rilasciaLock();
	},

	methods: {
		rilasciaLock: function () {
			utils.lock.release(this.lockHandle);
			this.lockHandle = null;
			this.lock = null;
		},

		aggiornaLock: function () {
			this.rilasciaLock();
			if (this.flgEditor == 1 && this.idTemplate > 0) this.lockHandle = utils.lock.acquire('REPORT_TEMPLATE', this.idTemplate, (stato) => this.lock = stato, () => this.ricaricaTemplate(this.idTemplate));
		},

		// Solo il template sbloccato: caricaTemplates sostituirebbe la lista e farebbe sparire le bozze
		ricaricaTemplate: function (id) {
			utils.get('core/reporttemplate', { ID_REPORT: this.idReport }, (response) => {
				var t = response.esito == 0 ? utils.array.select(response.data || [], 'ID_REPORT_TEMPLATE', id, 1)[0] : null;
				if (t == undefined || t == null) return;
				var i = this.templates.findIndex((x) => x.ID_REPORT_TEMPLATE == id);
				if (i >= 0) this.templates[i] = t;
				if (this.idTemplate == id) this.applicaTemplate(t);
			}, false, 1);
		},

		caricaTemplates: function (idDaSelezionare) {
			utils.get('core/reporttemplate', { ID_REPORT: this.idReport }, (response) => {
				if (response.esito == 0) {
					this.templates = response.data || [];
					var scelto = null;
					if (idDaSelezionare != undefined) {
						scelto = utils.array.select(this.templates, 'ID_REPORT_TEMPLATE', idDaSelezionare, 1)[0];
					}
					if (scelto == undefined || scelto == null) {
						scelto = utils.array.select(this.templates, 'FLG_DEFAULT', 1, 1)[0];
					}
					if (scelto == undefined || scelto == null) {
						scelto = this.templates[0];
					}
					if (scelto != undefined && scelto != null) {
						this.idTemplate = scelto.ID_REPORT_TEMPLATE;
						this.applicaTemplate(scelto);
					}
				}
			}, false, 1);
		},

		// Le impostazioni salvate sovrascrivono i default, le chiavi mancanti restano al default
		applicaTemplate: function (t) {
			var salvate = {};
			try {
				salvate = JSON.parse(t.IMPOSTAZIONI || '{}') || {};
			} catch (e) {
				salvate = {};
			}
			var nuova = utils.clone(CFG_DEFAULT);
			for (var k in salvate) {
				if (k == 'COLONNE' || k == 'TESTI' || k == 'ORDINE_COLONNE') continue;
				nuova[k] = salvate[k];
			}
			Object.assign(nuova.COLONNE, salvate.COLONNE || {});
			Object.assign(nuova.TESTI, salvate.TESTI || {});
			nuova.ORDINE_COLONNE = this.ordineValido(salvate.ORDINE_COLONNE);
			this.cfg = nuova;
			this.modello = { NOME: t.NOME };
			// L'anteprima non si tocca qui: applicaTemplate viene richiamata anche dal
			// ricaricamento dopo un salvataggio, e azzerarla farebbe sparire l'anteprima
			// appena richiesta. Si svuota solo dove il template cambia davvero.
		},

		// Template salvati prima di questa opzione, o con chiavi sconosciute: si torna
		// all'ordine standard, completando in coda le colonne mancanti.
		ordineValido: function (ordine) {
			var std = CFG_DEFAULT.ORDINE_COLONNE;
			var out = (ordine || []).filter((k) => std.indexOf(k) >= 0);
			std.forEach((k) => { if (out.indexOf(k) < 0) out.push(k); });
			return out;
		},

		// Scorrimento circolare dei testi, per chi preferisce sfogliare invece di
		// puntare il pill: 6 campi, l'ordine e' quello di campiTesto.
		scorriTesto: function (passo) {
			var n = this.campiTesto.length;
			var idx = this.campiTesto.findIndex((t) => t.campo == this.testoAttivo);
			this.testoAttivo = this.campiTesto[(idx + passo + n) % n].campo;
		},

		labelColonna: function (campo) {
			var c = utils.array.select(this.campiColonna, 'campo', campo, 1)[0];
			return (c != undefined) ? c.label : campo;
		},

		selezionaTemplate: function () {
			var t = utils.array.select(this.templates, 'ID_REPORT_TEMPLATE', this.idTemplate, 1)[0];
			if (t != undefined) {
				this.previewUrl = '';
				this.applicaTemplate(t);
			}
		},

		nuovo: function () {
			this.aggiungiBozza('Nuovo template', utils.clone(CFG_DEFAULT));
		},

		duplica: function () {
			this.aggiungiBozza(this.modello.NOME + ' (copia)', utils.clone(this.cfg));
		},

		// Bozza locale con id negativo: diventa un record vero al primo salvataggio
		aggiungiBozza: function (nome, cfg) {
			var idBozza = -1 * new Date().getTime();
			this.templates.push({
				ID_REPORT_TEMPLATE: idBozza,
				NOME: nome,
				IMPOSTAZIONI: JSON.stringify(cfg),
				FLG_DEFAULT: 0,
			});
			this.idTemplate = idBozza;
			this.cfg = cfg;
			this.modello = { NOME: nome };
			this.previewUrl = '';
			this.flgEditor = 1;
		},

		salva: function () {
			if (!this.modello.NOME) {
				utils.alert.warning('Indica un nome per il template');
				return;
			}
			var params = {
				ID_REPORT: this.idReport,
				NOME: this.modello.NOME,
				IMPOSTAZIONI: this.cfg,
			};
			if (this.isNuovo) {
				utils.post('core/reporttemplate/insert', params, (response) => {
					if (response.esito == 0) {
						utils.alert.success('Template salvato');
						this.caricaTemplates(response.id_inserito);
					}
				});
			} else {
				params.ID_REPORT_TEMPLATE = this.idTemplate;
				utils.put('core/reporttemplate/update', params, (response) => {
					if (response.esito == 0) {
						utils.alert.success('Template salvato');
						this.caricaTemplates(this.idTemplate);
					}
				});
			}
		},

		impostaPredefinito: function () {
			utils.put('core/reporttemplate/update', {
				ID_REPORT_TEMPLATE: this.idTemplate,
				ID_REPORT: this.idReport,
				NOME: this.modello.NOME,
				IMPOSTAZIONI: this.cfg,
				FLG_DEFAULT: 1,
			}, (response) => {
				if (response.esito == 0) {
					utils.alert.success('Template impostato come predefinito');
					this.caricaTemplates(this.idTemplate);
				}
			});
		},

		elimina: function () {
			var t = utils.array.select(this.templates, 'ID_REPORT_TEMPLATE', this.idTemplate, 1)[0];
			if (t == undefined) return;
			utils.alert.confirm('Eliminare il template "' + t.NOME + '"?', () => {
				utils.delete('core/reporttemplate/delete', { ID_REPORT_TEMPLATE: this.idTemplate }, (response) => {
					if (response.esito == 0) {
						this.idTemplate = null;
						this.previewUrl = '';
						this.caricaTemplates();
					}
				});
			}, this.$root);
		},

		urlCompleto: function (idTemplate, anteprima) {
			var url = utils.BASE_API + this.urlStampa + '&ID_TEMPLATE=' + idTemplate + utils.getSessionToken();
			if (anteprima) url += '&ANTEPRIMA=1&_=' + new Date().getTime();
			return url;
		},

		// L'anteprima e' sempre del template salvato: le modifiche non ancora salvate
		// non compaiono, il PDF lo genera il server.
		apriAnteprima: function () {
			if (this.isNuovo) {
				utils.alert.warning('Salva il template prima di vedere l\'anteprima');
				return;
			}
			this.previewUrl = this.urlCompleto(this.idTemplate, true);
			this.filters.openPopUp(this.id + '_anteprima');
		},

		stampa: function () {
			if (this.isNuovo) {
				utils.alert.warning('Salva il template prima di stampare');
				return;
			}
			window.open(this.urlCompleto(this.idTemplate, false));
		},
	},
};
</script>
